import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import CommunitySwitcher from "@/components/dropdown/CommunitySwitcher";
import { toggleSideBar } from "@/utils/sidebar";
import { useAuth } from "@/hooks/useAuth";

function AppBar({ title = "" }) {
  const { logout } = useAuth();

  return (
    <Navbar expand="lg" className="app-header">
      <div
        className="main-header-container container-fluid"
        style={{ minHeight: 45 }}
      >
        <div className="header-content-left">
          <SideBarToggler />
          <div className="d-flex align-items-center px-3">
            <span className="fs-16 fw-medium">{title}</span>
          </div>
        </div>

        <div />

        <div className="header-content-right">
          {/* <CommunitySwitcher /> */}
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link href="/">Account</Nav.Link>
              <Nav.Link onClick={logout}>
                Logout
                <i className="bi bi-box-arrow-right ms-2" />
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </div>
      </div>
    </Navbar>
  );
}

const SideBarToggler = () => {
  return (
    <div className="header-element" onClick={toggleSideBar}>
      <a
        aria-label="Hide Sidebar"
        className="sidemenu-toggle header-link animated-arrow hor-toggle horizontal-navtoggle"
        data-bs-toggle="sidebar"
      >
        <span></span>
      </a>
    </div>
  );
};

export default AppBar;
